/**
 * @flow
 * @relayHash 5be271afaceea310c154af3820c28ec5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateCategoryInput = {|
  id: string,
  name: string,
  clientMutationId?: ?string,
|};
export type CreateCategoryMutationVariables = {|
  input: CreateCategoryInput
|};
export type CreateCategoryMutationResponse = {|
  +createCategory: ?{|
    +newCategory: ?{|
      +id: string
    |}
  |}
|};
export type CreateCategoryMutation = {|
  variables: CreateCategoryMutationVariables,
  response: CreateCategoryMutationResponse,
|};
*/


/*
mutation CreateCategoryMutation(
  $input: CreateCategoryInput!
) {
  createCategory(input: $input) {
    newCategory {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateCategoryInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createCategory",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCategoryPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "newCategory",
        "storageKey": null,
        "args": null,
        "concreteType": "CategoryNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateCategoryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateCategoryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateCategoryMutation",
    "id": null,
    "text": "mutation CreateCategoryMutation(\n  $input: CreateCategoryInput!\n) {\n  createCategory(input: $input) {\n    newCategory {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4cd61ec3243fafc2763351feb7f8a76c';
module.exports = node;
